import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { ChevronRight } from "lucide-react";
import { colors, borderRadiusPx } from "../../../../theme";

const FooterNavCol = ({ title, links = [] }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Column Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 4,
            height: 16,
            borderRadius: borderRadiusPx.xs,
            backgroundColor: colors.primary.main,
          }}
        />
        <Typography
          sx={{
            fontSize: "0.95rem",
            fontWeight: 700,
            color: colors.neutral.white,
            letterSpacing: "0.02em",
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Links List */}
      <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0, display: "flex", flexDirection: "column", gap: 1.25 }}>
        {links.map((link) => {
          const isAnchor = Boolean(link.href);
          const linkTarget = link.target || (link.isExternal ? "_blank" : undefined);
          const linkRel = linkTarget === "_blank" ? "noreferrer noopener" : undefined;

          return (
            <Box component="li" key={link.label}>
              <Box
                component="a"
                href={link.path || link.href}
                target={linkTarget}
                rel={linkRel}
                className="autobet-footer-link"
                sx={{
                  color: colors.slate[300],
                  "&:hover": {
                    color: colors.neutral.white,
                  },
                }}
              >
                <ChevronRight size={14} className="link-arrow" color={colors.blue[400]} />
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    color: "inherit",
                    lineHeight: 1.5,
                  }}
                >
                  {link.label}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

FooterNavCol.propTypes = {
  title: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string,
      isExternal: PropTypes.bool,
    })
  ).isRequired,
};

export default FooterNavCol;
